import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import Masculino from "../pages/Masculino";
import Feminino from "../pages/Feminino";
import Geral from "../pages/Geral";
import Dashboard from "../pages/Dashboard";
import GTM from "../components/GTM/gtm";
import Parcas from "../pages/parcas";

export default function AppRouter() {
  return (
    <BrowserRouter>
    <GTM></GTM>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/masculino" element={<Masculino />} />
        <Route path="/pokemon" element={<Feminino />} />
        <Route path="/perfumes" element={<Geral />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/promodosparcas" element={<Parcas />} />
      </Routes>
    </BrowserRouter>
  );
}